module.exports = __webpack_public_path__ + "media/images/metronic/social/myspace-a48d7f0e924442adcc20bcd330b9de79.png";